import {NgModule} from "@angular/core";
import {DashboardStatusKomponentAvhengigheter} from "./komponenter/dashboard-status/dashboard-status";

@NgModule({
    providers: [
        DashboardStatusKomponentAvhengigheter,
    ]
})
export class DashboardModul {

}
